<lib-filter-list #assortmentList [configService]="configService"></lib-filter-list>
<ng-container *ngIf="showProductList && currentAssortment && currentAssortmentObj">
    <hr>
    <h4 translate>PRODUCTS</h4>
    <lib-filter-list #productsList [configService]="productListConfigService"></lib-filter-list>
</ng-container>